import { Close } from '@mui/icons-material';
import { Box, Typography, useTheme } from '@mui/material';
import { useMediaQuery } from '@mui/system';
import { ReactNode } from 'react';

import { selectActiveChapterId, useAppSelector } from '@/store';

type NewFeatureBannerProps = {
  children?: ReactNode;
  onClose?: () => void;
};

export const NewFeatureBanner = ({
  children,
  onClose,
}: NewFeatureBannerProps) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isMiniPlayerMounted = !!useAppSelector(selectActiveChapterId);
  const { xs, sm } = theme.dimensions.miniPlayer.height;

  if (isMobile) {
    return null;
  }

  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: isMiniPlayerMounted
          ? {
              xs: `calc(${xs}px + ${theme.spacing(3)})`,
              sm: `calc(${sm}px + ${theme.spacing(3)})`,
            }
          : '24px',
        left: '24px',
        width: 345,
        minHeight: 318,
        zIndex: 'snackbar',
        bgcolor: 'secondary.light',
        p: '15px',
        border: theme => `1px solid ${theme.palette.secondary.main}80`,
        borderRadius: 2,
        overflow: 'hidden',
        boxShadow: theme => theme.customShadows.newFeatureBanner,
      }}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-between',
          mb: 2,
        }}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: 103,
            height: 30,
            px: 0.5,
            py: 1,
            borderRadius: '3px',
            bgcolor: 'secondary.main',
          }}>
          <Typography variant="body2SemiBold" sx={{ color: 'white' }}>
            What&apos;s New
          </Typography>
        </Box>
        <Close
          onClick={onClose}
          sx={{
            width: '23px',
            height: '23px',
            cursor: 'pointer',
            color: 'secondary.main',
          }}
        />
      </Box>
      {children}
    </Box>
  );
};
